module.exports = __webpack_public_path__ + "static/media/fk.9144425b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fk.svg
// module id = 911
// module chunks = 0